export default __webpack_public_path__ + "static/media/mainCarPlaceholder.32fb7383.png";